/**
 * Simple Yotpo Disabled Handler
 * Prevents interaction on yotpo elements with yotpo-disabled class
 */

(function() {
  'use strict';

  function handleYotpoDisabled() {
    // Event delegation - handle all clicks on the document
    document.addEventListener('click', function(event) {
      const target = event.target.closest('a');
      
      // Check if it's a yotpo link with disabled class
      if (target && isYotpoDisabled(target)) {
        console.log('Yotpo: Blocked click on disabled element');
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
    }, true);

    // Also handle other interaction events
    ['mousedown', 'touchstart', 'keydown'].forEach(function(eventType) {
      document.addEventListener(eventType, function(event) {
        const target = event.target.closest('a');
        
        if (target && isYotpoDisabled(target)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }, true);
    });
  }

  function isYotpoDisabled(element) {
    if (!element || element.tagName !== 'A') return false;
    
    const classList = element.classList;
    
    // Check if has yotpo class (exact match or contains yotpo)
    const hasYotpoClass = classList.contains('yotpo') || 
                         Array.from(classList).some(cls => cls.includes('yotpo'));
    
    // Check if has disabled class
    const hasDisabledClass = classList.contains('yotpo-disabled');
    
    return hasYotpoClass && hasDisabledClass;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleYotpoDisabled);
  } else {
    handleYotpoDisabled();
  }

  // Make check function globally available
  window.isYotpoDisabled = isYotpoDisabled;

})();


